import { render, staticRenderFns } from "./nftDetail.vue?vue&type=template&id=f6575368&scoped=true"
import script from "./nftDetail.vue?vue&type=script&lang=js"
export * from "./nftDetail.vue?vue&type=script&lang=js"
import style0 from "./nftDetail.vue?vue&type=style&index=0&id=f6575368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6575368",
  null
  
)

export default component.exports